import {
  Chip,
  ClickAwayListener,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery
} from '@material-ui/core';
import { getUserDataStorage } from '../storageHelper';
import { FormSubmitCountGetResponse, FormSubmitsGetResponse } from '../types';
import { useApi } from './DynamicForms/fetchHook';
import { DateTime } from 'luxon';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  green: {
    color: 'green'
  },
  red: {
    color: 'red'
  },
  gray: {
    color: '#3a3a3a'
  },
  link: {
    '&:hover': {
      textDecoration: 'none'
    }
  },
  mainButton: {
    width: '100%',
    marginTop: 10,
    [theme.breakpoints.up('sm')]: {
      width: 250
    }
  },
  buttonContainer: {
    maxWidth: 1440,
    margin: '0 auto',
    paddingLeft: 24,
    paddingRight: 24
  },
  disabled: {
    cursor: 'not-allowed'
  }
}));

interface DashboardInfoCardProps {
  title: string;
  value: string;
  body?: JSX.Element;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DashboardInfoCard: React.FC<DashboardInfoCardProps> = ({
  title,
  value,
  body
}) => {
  const classes = useStyles();
  return (
    <div style={{ textAlign: 'center', flex: 1 }}>
      <Typography style={{ fontSize: 14 }} color="textSecondary">
        {title}
      </Typography>
      <Typography className={classes.gray}>{value}</Typography>
      {body}
    </div>
  );
};

const filterToday = (value: string) =>
  DateTime.fromISO(value) > DateTime.local().startOf('day');

const filteryesterday = (value: string) =>
  DateTime.fromISO(value) >
    DateTime.local().minus({ days: 1 }).startOf('day') &&
  DateTime.fromISO(value) < DateTime.local().startOf('day');

export const FormSummary = ({
  hideFilled = false,
  hideUnfinished = false
}: {
  hideFilled?: boolean;
  hideUnfinished?: boolean;
}) => {
  const [formSubmits] = useApi<FormSubmitsGetResponse>(
    `/api/submits?filledBy=${getUserDataStorage().email}`
  );

  const [incompleteSubmitsCount] = useApi<FormSubmitCountGetResponse>(
    `/api/submits/count?filledBy=${getUserDataStorage().email}&submitted=false`,
    () => hideFilled
  );
  const isMobileView = useMediaQuery('(max-width:640px)');
  const completeSubmits = formSubmits
    ? formSubmits.results.filter((submit) => submit.submitted === true)
    : null;
  const incompleteSubmits = formSubmits
    ? formSubmits.results.filter((submit) => submit.submitted === false)
    : null;

  const today = completeSubmits
    ? completeSubmits
        .map((result) => result.updated_at)
        .filter(filterToday)
        .length.toString()
    : '-';

  const yesterday = completeSubmits
    ? completeSubmits
        .map((result) => result.updated_at)
        .filter(filteryesterday)
        .length.toString()
    : '-';

  const total = completeSubmits ? completeSubmits.length : '-';

  const incompleteTotalUser = incompleteSubmits
    ? incompleteSubmits
        .filter((submit) => submit.filledBy === getUserDataStorage().email)
        .length.toString()
    : '-';

  const incompleteTotal = incompleteSubmitsCount?.count ?? '-';

  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const filledSmallString = `T: ${today} | E: ${yesterday} | Y: ${total} `;
  const filledCompleteString = `Lomakkeeni: Tänään ${today} | Eilen ${yesterday} | Yhteensä ${total}`;

  const inCompleteSmallString = `O: ${incompleteTotalUser} | Y: ${incompleteTotal}`;
  const inCompleteCompleteString = `Keskeneräiset: Omat ${incompleteTotalUser} | Yhteensä ${incompleteTotal}`;
  if (isMobileView) {
    return (
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <div>
          <Tooltip
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={
              hideUnfinished ? filledCompleteString : inCompleteCompleteString
            }
          >
            <Chip
              onClick={handleTooltipOpen}
              size="small"
              label={hideUnfinished ? filledSmallString : inCompleteSmallString}
            />
          </Tooltip>
        </div>
      </ClickAwayListener>
    );
  }

  return (
    <>
      <Table
        size="small"
        style={{
          border: 0,
          display: hideFilled ? 'none' : 'inherit'
        }}
      >
        <TableBody>
          <TableRow>
            <TableCell style={{ border: 0, fontWeight: 'bold' }}>
              Lomakkeeni:
            </TableCell>
            <TableCell style={{ border: 0 }}> Tänään</TableCell>
            <TableCell style={{ border: 0 }}>{today}</TableCell>
            <TableCell style={{ border: 0 }}> Eilen</TableCell>
            <TableCell style={{ border: 0 }}>{yesterday}</TableCell>
            <TableCell style={{ border: 0 }}> Yhteensä</TableCell>
            <TableCell style={{ border: 0 }}>{total}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Table
        size="small"
        style={{
          width: 400,
          border: 0,
          display: hideUnfinished ? 'none' : 'inherit'
        }}
      >
        <TableBody>
          <TableRow>
            <TableCell style={{ border: 0, fontWeight: 'bold' }}>
              Keskeneräiset:
            </TableCell>
            <TableCell style={{ border: 0 }}>Omat</TableCell>
            <TableCell style={{ border: 0 }}>{incompleteTotalUser}</TableCell>

            <TableCell style={{ border: 0 }}> Yhteensä</TableCell>
            <TableCell style={{ border: 0 }}>{incompleteTotal}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};
